import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { defaultIfEmpty, take, takeUntil } from 'rxjs/operators';
import { Project } from 'src/app/interfaces/api/project';
import { ProjectService } from 'src/app/services/api/projects/project.service';
import { TrackerService } from 'src/app/services/api/trackers/tracker.service';
import { ButtonComponent, ChipComponent } from 'ui-library';

@Component({
  selector: 'app-set-project-modal',
  imports: [
    FormsModule,
    TranslateModule,
    MatDialogModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatFormFieldModule,
    ButtonComponent,
    ChipComponent
  ],
  standalone: true,
  templateUrl: './set-project-modal.component.html',
  styleUrls: ['./set-project-modal.component.scss']
})

export class SetProjectModalComponent implements OnInit, OnDestroy {
  trackers: any[] = [];
  projects: any[] = [];
  projectId?: string;
  destroy$ = new Subject<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SetProjectModalComponent>,
    private trackerService: TrackerService,
    private projectService: ProjectService) {
    this.trackers = this.data.trackers;
  }

  ngOnInit(): void {
    this.projectService.getProjectListByUser({}).pipe(takeUntil(this.destroy$)).pipe(take(1), defaultIfEmpty([])).subscribe((projects: Project[] | null) => {
      this.projects = projects || [];
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setProject() {
    if (this.projectId)
      this.trackerService.setProject(this.trackers.map(t => t.uuid), this.projectId).pipe(take(1), defaultIfEmpty(null)).subscribe(() => {
        this.dialogRef.close();
      })
  }

}
